/**
 * 運送引受書一覧
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import validators from '@/rahmen/validators'
import indexeddb from '@/ddv2.library/indexeddb'

import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'

import DdSearchList from '@/components/DdSearchList'
import DdCodeTextBox from '../../components/DdCodeTextBox.vue'
import DdDateRangeBox from '@/components/DdDateRangeBox'

export default {
  name: 'RcoUnsohikiukeList',
  mixins: [flowMixin],
  components: {
    DdSearchList,
    DdCodeTextBox,
    DdDateRangeBox
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,

    rows: [],
    conditions: {
      juchuEigyoshoId: null,
      juchuStartYmdString: '',
      juchuEndYmdString: '',
      tokuisakiId: null
    },
    conditionDetails: [
      { key: 'juchuEigyoshoId', name: '受注営業所', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msteigyosho' },
      { key: 'juchuYmdFromTo', name: '引受日', value: 'juchuYmdFromTo', type: 'value', delete: false, showValue: true, convertValue: false },
      { key: 'tokuisakiId', name: '得意先', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msttorihikisaki' }
    ],
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    modeKengen: 0
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      eigyoshoList: 'DDMasters/mstEigyosho',
      userEigyoshoCd: 'users/eigyoshoCd',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.juchuYmd = elem.juchuYmd ? filter.dateFormatter(elem.juchuYmd) : ''
        elem.juchuEigyoshoDisp = elem.juchuEigyoshoCd ? elem.juchuEigyoshoCd + ' : ' + elem.juchuEigyoshoNm : ''
        elem.uketsukeYmd = elem.uketsukeYmd ? filter.dateFormatter(elem.uketsukeYmd) : ''
        elem.tokuisakiDisp = elem.tokuisakiCd ? elem.tokuisakiCd + ' : ' + elem.tokuisakiNm : ''
        elem.niukeninDisp = elem.niukeninCd ? elem.niukeninCd + ' : ' + elem.niukeninNm : elem.niukeninBiko
        elem.hatsuchiDisp = elem.hatsuchiCd ? elem.hatsuchiCd + ' : ' + elem.hatsuchiNm : elem.hatsuchiBiko
        elem.hatsuchiYmdHmsDisp = (elem.hatsuchiYmd ? filter.dateFormatter(elem.hatsuchiYmd) : '') + ' ' + (elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : elem.hatsuchiHmsBiko ?? '')
        elem.chakuchiDisp = elem.chakuchiCd ? elem.chakuchiCd + ' : ' + elem.chakuchiNm : elem.chakuchiBiko
        elem.chakuchiYmdHmsDisp = (elem.chakuchiYmd ? filter.dateFormatter(elem.chakuchiYmd) : '') + ' ' + (elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : elem.chakuchiHmsBiko ?? '')
        elem.unsoHokenKanyuItakuFlg = elem.unsoHokenKanyuItakuFlg ? '有' : '無'
        elem.hinmeiDisp = elem.hinmeiCd ? elem.hinmeiCd + ' : ' + elem.hinmeiNm : elem.hinmeiBiko
        elem.juchuJuryo = elem.juchuJuryo ? filter.numericFormatter(elem.juchuJuryo) : ''
        elem.juchuSuryo = elem.juchuSuryo ? filter.numericFormatter(elem.juchuSuryo) : ''
        elem.juchuSharyoSuryo = elem.juchuSharyoSuryo ? filter.numericFormatter(elem.juchuSharyoSuryo) : ''
        elem.tsumikomiUmuFlg = elem.tsumikomiUmuFlg ? '有' : '無'
        elem.tsumikomiSagyoJikan = elem.tsumikomiSagyoJikan ? filter.minToTimeFormatter(elem.tsumikomiSagyoJikan) : ''
        elem.torioroshiUmuFlg = elem.torioroshiUmuFlg ? '有' : '無'
        elem.torioroshiSagyoJikan = elem.torioroshiSagyoJikan ? filter.minToTimeFormatter(elem.torioroshiSagyoJikan) : ''
        elem.kihonUnchin = elem.kihonUnchin ? filter.numericFormatter(elem.kihonUnchin) : ''
        elem.nenryoSurcharge = elem.nenryoSurcharge ? filter.numericFormatter(elem.nenryoSurcharge) : ''
        elem.hiwayPrice = elem.hiwayPrice ? filter.numericFormatter(elem.hiwayPrice) : ''
        elem.tsumikomiKingaku = elem.tsumikomiKingaku ? filter.numericFormatter(elem.tsumikomiKingaku) : ''
        elem.unchinHokaKingaku = elem.unchinHokaKingaku ? filter.numericFormatter(elem.unchinHokaKingaku) : ''
        elem.hokanKingaku = elem.hokanKingaku ? filter.numericFormatter(elem.hokanKingaku) : ''
        elem.torioroshiKingaku = elem.torioroshiKingaku ? filter.numericFormatter(elem.torioroshiKingaku) : ''
        elem.niekiKingaku = elem.niekiKingaku ? filter.numericFormatter(elem.niekiKingaku) : ''
        elem.unchinHokaHikazei = elem.unchinHokaHikazei ? filter.numericFormatter(elem.unchinHokaHikazei) : ''
        elem.tatekaekinHikazei = elem.tatekaekinHikazei ? filter.numericFormatter(elem.tatekaekinHikazei) : ''
        elem.taikiJikan = elem.taikiJikan ? filter.minToTimeFormatter(elem.taikiJikan) : ''
        elem.taikiJikanTanka = elem.taikiJikanTanka ? filter.numericFormatter(elem.taikiJikanTanka) : ''
        elem.taikiJikanKingaku = elem.taikiJikanKingaku ? filter.numericFormatter(elem.taikiJikanKingaku) : ''
        elem.warimashiTaishoJikan = elem.warimashiTaishoJikan ? filter.minToTimeFormatter(elem.warimashiTaishoJikan) : ''
        elem.warimashiJikanTanka = elem.warimashiJikanTanka ? filter.numericFormatter(elem.warimashiJikanTanka) : ''
        elem.jikanWarimashiKingaku = elem.jikanWarimashiKingaku ? filter.numericFormatter(elem.jikanWarimashiKingaku) : ''
        elem.warimashiTaishoKyori = elem.warimashiTaishoKyori ? filter.numericFormatter(elem.warimashiTaishoKyori) : ''
        elem.warimashiKyoriTanka = elem.warimashiKyoriTanka ? filter.numericFormatter(elem.warimashiKyoriTanka) : ''
        elem.kyoriWarimashiKingaku = elem.kyoriWarimashiKingaku ? filter.numericFormatter(elem.kyoriWarimashiKingaku) : ''
        elem.warimashiSonotaKingsku = elem.warimashiSonotaKingsku ? filter.numericFormatter(elem.warimashiSonotaKingsku) : ''
        elem.futaiGyomuKingaku1 = elem.futaiGyomuKingaku1 ? filter.numericFormatter(elem.futaiGyomuKingaku1) : ''
        elem.futaiGyomuKingaku2 = elem.futaiGyomuKingaku2 ? filter.numericFormatter(elem.futaiGyomuKingaku2) : ''
        elem.futaiGyomuKingaku3 = elem.futaiGyomuKingaku3 ? filter.numericFormatter(elem.futaiGyomuKingaku3) : ''
        elem.futaiGyomuKingaku4 = elem.futaiGyomuKingaku4 ? filter.numericFormatter(elem.futaiGyomuKingaku4) : ''
        elem.futaiGyomuKingaku5 = elem.futaiGyomuKingaku5 ? filter.numericFormatter(elem.futaiGyomuKingaku5) : ''
        elem.futaiGyomuKingaku6 = elem.futaiGyomuKingaku6 ? filter.numericFormatter(elem.futaiGyomuKingaku6) : ''
        elem.futaiGyomuKingaku7 = elem.futaiGyomuKingaku7 ? filter.numericFormatter(elem.futaiGyomuKingaku7) : ''
        elem.futaiGyomuKingaku8 = elem.futaiGyomuKingaku8 ? filter.numericFormatter(elem.futaiGyomuKingaku8) : ''
        elem.futaiGyomuKingaku9 = elem.futaiGyomuKingaku9 ? filter.numericFormatter(elem.futaiGyomuKingaku9) : ''
        elem.futaiGyomuKingaku10 = elem.futaiGyomuKingaku10 ? filter.numericFormatter(elem.futaiGyomuKingaku10) : ''
        elem.futaiGyomuKingaku = elem.futaiGyomuKingaku ? filter.numericFormatter(elem.futaiGyomuKingaku) : ''
        elem.kazeiTaxAmount = elem.kazeiTaxAmount ? filter.numericFormatter(elem.kazeiTaxAmount) : ''
        elem.seikyuGokeiTaxKomi = elem.seikyuKingaku ? filter.numericFormatter(parseFloat(elem.seikyuKingaku, 10) + parseFloat(elem.kazeiTaxAmount, 10)) : ''
        elem.nyukinYoteiYmd = elem.nyukinYoteiYmd ? filter.dateFormatter(elem.nyukinYoteiYmd) : ''
        elem.hatsuchiYoteiYmdHmsDisp = (elem.hatsuchiYoteiYmd ? filter.dateFormatter(elem.hatsuchiYoteiYmd) : '') + ' ' + (elem.hatsuchiYoteiHms ? (elem.hatsuchiYoteiHms).slice(0, 5) : elem.hatsuchiYoteiHmsBiko ?? '')
        elem.chakuchiYoteiYmdHmsDisp = (elem.chakuchiYoteiYmd ? filter.dateFormatter(elem.chakuchiYoteiYmd) : '') + ' ' + (elem.chakuchiYoteiHms ? (elem.chakuchiYoteiHms).slice(0, 5) : elem.chakuchiYoteiHmsBiko ?? '')
        return elem
      })
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      const self = this
      return self.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01' && (self.eigyoshoLockFlg === true || (self.eigyoshoLockFlg === false && elem.eigyoshoCd === self.userEigyoshoCd))
      })
    },
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.tokuisakiFlg === true
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    createButtonDisp () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  watch: {
    /**
     * 検索条件簡易表示用
     * @param {} n
     */
    // 引受日
    'conditions.juchuStartYmdString': function (n) {
      var juchuYmdFromTo = ![undefined, null, ''].includes(this.conditions.juchuStartYmdString) ? this.conditions.juchuStartYmdString.slice(-5) : ''
      juchuYmdFromTo = juchuYmdFromTo + (![undefined, null, ''].includes(this.conditions.juchuEndYmdString) ? '～' + this.conditions.juchuEndYmdString.slice(-5) : '')
      this.conditions.juchuYmdFromTo = juchuYmdFromTo
    },
    'conditions.juchuEndYmdString': function (n) {
      var juchuYmdFromTo = ![undefined, null, ''].includes(this.conditions.juchuStartYmdString) ? this.conditions.juchuStartYmdString.slice(-5) : ''
      juchuYmdFromTo = juchuYmdFromTo + (![undefined, null, ''].includes(this.conditions.juchuEndYmdString) ? '～' + this.conditions.juchuEndYmdString.slice(-5) : '')
      this.conditions.juchuYmdFromTo = juchuYmdFromTo
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize () {
      console.log('initialize')
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'msttorihikisaki'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('RcoJuchuList.defineHeaderPromise')
            self.headers = [
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: '受注番号', value: 'juchuNo' },
              { text: '受注日', value: 'juchuYmd' },
              { text: '受注営業所', value: 'juchuEigyoshoDisp' },
              { text: '申込日', value: 'uketsukeYmd' },
              { text: '(申込者)名称', value: 'tokuisakiDisp' },
              { text: '(申込者)電話番号', value: 'ninushiTelNo' },
              { text: '(申込者)FAX番号', value: 'ninushiFaxNo' },
              { text: '(申込者)住所', value: 'ninushiJusho' },
              { text: '(申込者)メールアドレス', value: 'ninushiMailAddress' },
              { text: '(申込者)担当者名', value: 'ninushiTantoshaNm' },
              { text: '(荷受人)名称', value: 'niukeninDisp' },
              { text: '(荷受人)電話番号', value: 'niukeninTelNo' },
              { text: '(荷受人)FAX番号', value: 'niukeninFaxNo' },
              { text: '(荷受人)住所', value: 'niukeninJusho' },
              { text: '(荷受人)メールアドレス', value: 'niukeninMailAddress' },
              { text: '(荷受人)担当者名', value: 'niukeninTantoshaNm' },
              { text: '(引受者)名称', value: 'jishaKaishaNm' },
              { text: '(引受者)電話番号', value: 'jishaTelNo' },
              { text: '(引受者)FAX番号', value: 'jishaFaxNo' },
              { text: '(引受者)住所', value: 'jishaJusho' },
              { text: '(引受者)メールアドレス', value: 'jishaMailAddress' },
              { text: '(引受者)担当者名', value: 'jishaShanaiTantosha' },
              { text: '集荷先/発送地', value: 'hatsuchiDisp', align: 'center' },
              { text: '希望集荷/発送日時', value: 'hatsuchiYmdHmsDisp', align: 'center' },
              { text: '配達先/到着地', value: 'chakuchiDisp', align: 'center' },
              { text: '希望配達/到着日時', value: 'chakuchiYmdHmsDisp', align: 'center' },
              { text: '運送保険加入委託', value: 'unsoHokenKanyuItakuFlg', align: 'center' },
              { text: '品名', value: 'hinmeiDisp', align: 'center' },
              { text: '品質', value: 'hinsitsuSbtNm', align: 'center' },
              { text: '重量/容積', value: 'juchuJuryo', align: 'right' },
              { text: '単位', value: 'unitKbnNm', align: 'center' },
              { text: '個数', value: 'juchuSuryo', align: 'right' },
              { text: '荷造り種類', value: 'nisugataBiko' },
              { text: '運送扱種別', value: 'unsoAtsukaiSbtNm', align: 'center' },
              { text: '車種', value: 'seikyuShashuSbtNm', align: 'center' },
              { text: '台数', value: 'juchuSharyoSuryo', align: 'right' },
              { text: '積込作業', value: 'tsumikomiUmuFlg', align: 'center' },
              { text: '積込作業時間', value: 'tsumikomiSagyoJikan', align: 'center' },
              { text: '取卸作業', value: 'torioroshiUmuFlg', align: 'center' },
              { text: '取卸作業時間', value: 'torioroshiSagyoJikan', align: 'center' },
              { text: '付帯業務内容', value: 'futaiGyomuBiko' },
              { text: '運賃', value: 'kihonUnchin', align: 'right' },
              { text: '燃料サーチャージ', value: 'nenryoSurcharge', align: 'right' },
              { text: '高速料金', value: 'hiwayPrice', align: 'right' },
              { text: '積込金額', value: 'tsumikomiKingaku', align: 'right' },
              { text: '運賃(その他)', value: 'unchinHokaKingaku', align: 'right' },
              { text: '保管料', value: 'hokanKingaku', align: 'right' },
              { text: '取卸金額', value: 'torioroshiKingaku', align: 'right' },
              { text: '荷役料', value: 'niekiKingaku', align: 'right' },
              { text: '運賃他(税込)', value: 'unchinHokaHikazei', align: 'right' },
              { text: '立替金(税込)', value: 'tatekaekinHikazei', align: 'right' },
              { text: '待機時間', value: 'taikiJikan', align: 'center' },
              { text: '待機時間単価', value: 'taikiJikanTanka', align: 'right' },
              { text: '待機時間金額', value: 'taikiJikanKingaku', align: 'right' },
              { text: '割増対象時間', value: 'warimashiTaishoJikan', align: 'center' },
              { text: '割増単価(時間)', value: 'warimashiJikanTanka', align: 'right' },
              { text: '割増金額(時間)', value: 'jikanWarimashiKingaku', align: 'right' },
              { text: '割増対象距離', value: 'warimashiTaishoKyori', align: 'center' },
              { text: '割増単価(距離)', value: 'warimashiKyoriTanka', align: 'right' },
              { text: '割増金額(距離)', value: 'kyoriWarimashiKingaku', align: 'right' },
              { text: '割増その他', value: 'warimashiSonotaKingsku', align: 'right' },
              { text: '品代金の取立て', value: 'futaiGyomuKingaku1', align: 'right' },
              { text: '荷掛金の立替え', value: 'futaiGyomuKingaku2', align: 'right' },
              { text: '荷造り', value: 'futaiGyomuKingaku3', align: 'right' },
              { text: '仕分け', value: 'futaiGyomuKingaku4', align: 'right' },
              { text: '保管', value: 'futaiGyomuKingaku5', align: 'right' },
              { text: '検収及び検品', value: 'futaiGyomuKingaku6', align: 'right' },
              { text: '横持ち及び縦持ち', value: 'futaiGyomuKingaku7', align: 'right' },
              { text: '棚入れ', value: 'futaiGyomuKingaku8', align: 'right' },
              { text: 'ラベル貼り', value: 'futaiGyomuKingaku9', align: 'right' },
              { text: 'はい作業', value: 'futaiGyomuKingaku10', align: 'right' },
              { text: 'その他付帯業務', value: 'futaiGyomuKingaku', align: 'right' },
              { text: '消費税', value: 'kazeiTaxAmount', align: 'right' },
              { text: '請求合計', value: 'seikyuGokeiTaxKomi', align: 'right' },
              { text: '入金方法', value: 'nyukinKbnNm', align: 'center' },
              { text: '入金予定日', value: 'nyukinYoteiYmd', align: 'center' }
              /*
              { text: '予定集荷/発送日時', value: 'hatsuchiYoteiYmdHmsDisp' },
              { text: '予定配達/到着日時', value: 'chakuchiYoteiYmdHmsDisp' },
              { text: '予定/実績車両', value: 'sharyoId' },
              { text: '予定/実績乗務員', value: 'jininId' }
              */
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('RcoJuchuList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('RcoJuchuList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('RcoJuchuList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('RcoJuchuList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('RcoJuchuList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      self.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      // 選択状態初期化
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2prmd0020/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
          }
        }
      }
      this.search(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.initBindVariables()
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      if (this.conditions.juchuStartYmdString && this.conditions.juchuEndYmdString) {
        const msg1 = validators.compareDate(this.conditions.juchuStartYmdString, this.conditions.juchuEndYmdString)
        if (msg1 !== undefined) {
          this.$refs.juchuStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.$refs.juchuEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.setInvalidSummaryMessage('COME0014')
          return false
        }
      }
      return true
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      const d = new Date()
      const userEigyoshoInfo = indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.userEigyoshoCd, date.getCurrentDate())
      const initConditions = {
        juchuEigyoshoId: userEigyoshoInfo ? userEigyoshoInfo.id : null,
        juchuStartYmdString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
        juchuEndYmdString: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
        tokuisakiId: null
      }
      this.conditions = {
        ...initConditions,
        // 表示用
        juchuYmdFromTo: initConditions.juchuStartYmdString.slice(-5) + '～' + initConditions.juchuEndYmdString.slice(-5),
        tokuisakiNm: ''
      }
      this.searchText = ''
      this.rows = []
      this.page = 1
    }
  }
}
